import { render, staticRenderFns } from "./NewTicketModal.vue?vue&type=template&id=677d9fe1&"
import script from "./NewTicketModal.vue?vue&type=script&lang=ts&"
export * from "./NewTicketModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm});qInstall(component, 'directives', {ClosePopup});
